import React, {useEffect, useState} from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    Tabs,
    Tab,
    Button,
    Divider,
    IconButton,
    TextField,
} from "@mui/material";
import {styled} from "@mui/system";
import {ApiDetails, KEY} from "../../../../dummyData";
import FormComponent from "../Form/FormComponent";
import MessagesComponent from "../Message/MessagesComponent";
import TenantFiles from "../Download Files/TenantFiles";
import TenantReport from "../Report/TenantReport";
import CryptoJS from "crypto-js";
import Account from "../Account/Account";
import {showSnackbar} from "../../../../components/SnackBar/SnackBar";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@mui/material/DialogContent";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import DialogActions from "@mui/material/DialogActions";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import Textarea from "@mui/joy/Textarea";
import Avatar from "@mui/material/Avatar";
import {Field, Form, Formik} from "formik";

const themeColor = "#2C5283";

const StyledCard = styled(Card)(({theme}) => ({
    marginBottom: theme.spacing(2),
    border: "1px solid #DDE6ED",
    borderRadius: theme.spacing(1),
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({}) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
    },
    '& .MuiDialogTitle-root': {
        padding: '16px 24px',
        borderBottom: '1px solid #e0e0e0',
    },
    '& .MuiDialogContent-root': {
        padding: '24px',
    },
    '& .MuiDialogActions-root': {
        padding: '12px 24px',
        borderTop: '1px solid #e0e0e0',
    },
}));

const DialogHeaderStyled = styled(DialogTitle)(({error}) => ({
    color: error ? '#e74c3c' : '#2c3e50',
    fontWeight: 600,
    fontSize: '1.25rem',
    textAlign: 'center',
}));

// Mock stringAvatar function (replace with actual implementation)
const stringAvatar = (name) => ({
    sx: {
        bgcolor: '#2C5283',
    },
    children: name ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : '',
});

const RightSide = ({tenantID, tenantData}) => {
    const [accountNumber, setAccountNumber] = useState(tenantData.account_number);
    const [tenantInfo, setTenantInfo] = useState({
        id: tenantID,
        name: tenantData.first_name,
        last_name: tenantData.last_name,
        account_number: tenantData.account_number,
    });

    useEffect(() => {
        setAccountNumber(tenantData.account_number);
        setTenantInfo({
            id: tenantID,
            name: tenantData.first_name,
            last_name: tenantData.last_name,
            account_number: tenantData.account_number,
        });
    }, [tenantData, tenantID]);

    let myMapDetailsDecrypted = "";
    try {
        myMapDetailsDecrypted = CryptoJS.AES.decrypt(localStorage.getItem("myMap"), KEY);
    } catch (e) {
        console.log(e);
    }

    const originalText = myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8);

    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const [files, setFiles] = useState({
        defaults: {
            "tenant_photo": "",
            "photo_of_national_id_front": "",
            "photo_of_national_id_back": "",
            "copy_of_contract": "",
            "inventory_checklist": ""
        }
    });

    useEffect(() => {
        fetch(
            ApiDetails + "pegasus/visionary/tenant/fetch/documents",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
                },
                body: JSON.stringify({
                    tenant_id: tenantID,
                }),
            }
        )
            .then(async (response) => {
                let data = await response.json();
                if (response.status === 200) {
                    console.log("Tenant documents");
                    console.log(data.documents);
                    setFiles(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [tenantID]);

    const sendCredentials = () => {
        let values = {
            tenant_id: tenantData.tenant_id,
            property_id: tenantData.property_id,
            phone_number: tenantData.phone_number,
            secondary_phone_number: tenantData.secondary_phone_number,
            first_name: tenantData.first_name,
            account_number: tenantData.account_number,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/credentials", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Credentials sent successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                } else if (response.status === 500) {
                    showSnackbar({
                        title: "Error!",
                        message: "Could not send credentials.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
            });
    };

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        amount: "",
        description: "",
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
    };

    const addArrears = () => {
        if (!formData.amount || !formData.description) {
            showSnackbar({
                title: "Error!",
                message: "Amount and description are required.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        let body = {
            tenant_id: tenantID,
            description: formData.description,
            amount: parseInt(formData.amount),
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/add/arrears", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Arrear added successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                    setOpen(false);
                    setFormData({amount: "", description: ""});
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Kindly try again later.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
            })
            .catch((err) => {
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
            });
    };

    const [transactionModal, setTransactionModal] = useState(false);
    const [dateFrom, setDateFrom] = useState(new Date());
    const [addingTransaction, setAddingTransaction] = useState(false);

    const addTransaction = (values) => {
        if (!values.amount) {
            showSnackbar({
                title: "Error!",
                message: "Transaction amount cannot be empty.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        if (!dateFrom) {
            showSnackbar({
                title: "Error!",
                message: "Transaction date cannot be empty.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        setAddingTransaction(true);

        let body = {
            TransactionType: "Pay Bill",
            TransID: "**********",
            TransTime: dateFrom.toISOString(),
            TransAmount: parseFloat(values.amount),
            BusinessShortCode: "",
            BillRefNumber: accountNumber,
            InvoiceNumber: "",
            OrgAccountBalance: "00.00",
            ThirdPartyTransID: "",
            MSISDN: "",
            FirstName: "",
            tenant_id: tenantID,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/payments/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Transaction added successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Transaction not added.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
                setAddingTransaction(false);
                setTransactionModal(false);
                setDateFrom(new Date());
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Failed updating tenant payment.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setAddingTransaction(false);
                setTransactionModal(false);
                window.location.reload();
            });
    };

    const [messageModal, setMessageModal] = useState(false);
    const [broadcastMessage, setBroadcastMessage] = useState("");
    const [messageLoading, setMessageLoading] = useState(false);

    const sendMessage = () => {
        if (!broadcastMessage) {
            showSnackbar({
                title: "Error!",
                message: "Cannot send an empty message.",
                type: "error",
                position: {vertical: "bottom", horizontal: "right"},
            });
            return;
        }

        setMessageLoading(true);

        let values = {
            message: broadcastMessage,
            tenant_id: tenantData.tenant_id,
            first_name: tenantData.first_name,
            phone_number: tenantData.phone_number,
            property_id: tenantData.property_id,
            secondary_phone_number: tenantData.secondary_phone_number,
            landlord_id: JSON.parse(originalText)[0][1],
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/message", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"
            },
            body: JSON.stringify(values),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Message sent successfully.",
                        type: "success",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                    setMessageModal(false);
                    setBroadcastMessage("");
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Something went wrong. Call customer care for assistance.",
                        type: "error",
                        position: {vertical: "bottom", horizontal: "right"},
                    });
                }
                setMessageLoading(false);
            })
            .catch((err) => {
                console.log(err);
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Call customer care for assistance.",
                    type: "error",
                    position: {vertical: "bottom", horizontal: "right"},
                });
                setMessageLoading(false);
            });
    };

    const handleClose = () => {
        setOpen(false);
        setMessageModal(false);
        setTransactionModal(false);
        setFormData({amount: "", description: ""});
        setBroadcastMessage("");
        setDateFrom(new Date());
    };

    const initialValues = {
        amount: "",
    };


    return (
        <>
            <StyledDialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Add Arrears</DialogHeaderStyled>
                <DialogContent>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        <TextField
                            label="Amount"
                            name="amount"
                            type="number"
                            variant="outlined"
                            fullWidth
                            value={formData.amount}
                            onChange={handleChange}
                            InputLabelProps={{
                                sx: { color: "#5A5A5A", fontSize: "0.9rem" },
                            }}
                            InputProps={{
                                style: {
                                    backgroundColor: "#FFF",
                                    borderRadius: "8px",
                                    boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                },
                            }}
                        />
                        <TextField
                            label="Description"
                            name="description"
                            type="text"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            value={formData.description}
                            onChange={handleChange}
                            InputLabelProps={{
                                sx: { color: "#5A5A5A", fontSize: "0.9rem" },
                            }}
                            InputProps={{
                                style: {
                                    backgroundColor: "#FFF",
                                    borderRadius: "8px",
                                    boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                },
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                        sx={{ mr: 2, borderRadius: "10px", textTransform: "none" }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={addArrears}
                        loading={false}
                        startIcon={<SendIcon />}
                        loadingPosition="start"
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                            "&:hover": { background: "#1E3A66" },
                        }}
                    >
                        Submit
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            <StyledDialog
                open={messageModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Message to {tenantData.first_name}</DialogHeaderStyled>
                <DialogContent>
                    <Textarea
                        minRows={5}
                        placeholder="Type message .."
                        onChange={(event) => setBroadcastMessage(event.target.value)}
                        value={broadcastMessage}
                        sx={{ width: "100%", borderRadius: "8px" }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="inherit"
                        sx={{ mr: 2, borderRadius: "10px", textTransform: "none" }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={sendMessage}
                        loading={messageLoading}
                        startIcon={<SendIcon />}
                        loadingPosition="start"
                        sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                            "&:hover": { background: "#1E3A66" },
                        }}
                    >
                        Send
                    </LoadingButton>
                </DialogActions>
            </StyledDialog>

            <StyledDialog
                open={transactionModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogHeaderStyled>Record Payment</DialogHeaderStyled>
                <DialogContent>
                    <Box sx={{ textAlign: "center", mb: 3 }}>
                        <Avatar
                            {...stringAvatar(`${tenantInfo.name} ${tenantInfo.last_name}`)}
                            sx={{ width: 64, height: 64, margin: "0 auto 16px", fontSize: 24 }}
                        />
                        <Typography variant="h6">
                            {tenantInfo.name} {tenantInfo.last_name}
                        </Typography>
                    </Box>
                    <Formik initialValues={initialValues} onSubmit={addTransaction}>
                        {() => (
                            <Form noValidate>
                                <Box sx={{ mb: 3 }}>
                                    <Field
                                        as={TextField}
                                        name="amount"
                                        label="Amount"
                                        type="number"
                                        fullWidth
                                        required
                                        variant="outlined"
                                        helperText="Enter the payment amount"
                                        InputLabelProps={{
                                            sx: { color: "#5A5A5A", fontSize: "0.9rem" },
                                        }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: "#FFF",
                                                borderRadius: "8px",
                                                boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                            },
                                        }}
                                    />
                                </Box>
                                <Box sx={{ mb: 3 }}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            disableFuture
                                            label="Payment Date"
                                            openTo="day"
                                            views={["year", "month", "day"]}
                                            value={dateFrom}
                                            onChange={(newValue) => setDateFrom(newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        sx: { color: "#5A5A5A", fontSize: "0.9rem" },
                                                    }}
                                                    sx={{
                                                        backgroundColor: "#FFF",
                                                        borderRadius: "8px",
                                                        boxShadow: "inset 0px 1px 6px rgba(0, 0, 0, 0.1)",
                                                    }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button
                                        onClick={handleClose}
                                        variant="outlined"
                                        color="inherit"
                                        sx={{ mr: 2, borderRadius: "10px", textTransform: "none" }}
                                    >
                                        Cancel
                                    </Button>
                                    <LoadingButton
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        loading={addingTransaction}
                                        startIcon={<SendIcon />}
                                        loadingPosition="start"
                                        sx={{
                                            borderRadius: "10px",
                                            textTransform: "none",
                                            background: "linear-gradient(90deg, #2C5283, #25446E)",
                                            "&:hover": { background: "#1E3A66" },
                                        }}
                                    >
                                        Record Payment
                                    </LoadingButton>
                                </Box>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </StyledDialog>

            <Grid item xs={15} md={8}>
                {/* Tabs Section */}
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{marginBottom: 2}}
                >
                    <Tab label="Account"/>
                    <Tab label="Edit Details"/>
                    <Tab label="Messages"/>
                    <Tab label="Files"/>
                    <Tab label="Report"/>
                </Tabs>

                {/* Tab Content */}
                {activeTab === 0 && (
                    <StyledCard>
                        <CardContent>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >

                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color={themeColor}
                                    gutterBottom
                                >
                                    Account
                                </Typography>

                                <Box sx={{display: "flex", gap: 1}}>
                                    <Button variant="outlined"
                                            sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                            onClick={() => {
                                                setTransactionModal(true)
                                            }}>
                                        Make Payment
                                    </Button>
                                    <Button variant="outlined"
                                            sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                            onClick={() => {
                                                setOpen(true)
                                            }}>
                                        Add Arrear
                                    </Button>
                                </Box>
                            </Box>

                            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

                            <Account tenantID={tenantID}/>

                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 1 && (
                    <StyledCard>
                        <CardContent>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Update Tenant Information
                            </Typography>

                            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

                            <Typography variant="body2" color="textSecondary">
                                <FormComponent tenatDetails={tenantData} originalDetails={originalText}/>
                            </Typography>
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 2 && (
                    <StyledCard>
                        <CardContent>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >

                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color={themeColor}
                                    gutterBottom
                                >
                                    Tenant Messages
                                </Typography>

                                <Button variant="outlined"
                                        sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                        onClick={()=> setMessageModal(true)}>

                                    Send SMS
                                </Button>

                                <Button variant="outlined"
                                        sx={{textTransform: "none", backgroundColor: "#FBF4F0"}}
                                        onClick={sendCredentials}>
                                    Resend Credentials
                                </Button>
                            </Box>

                            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

                            <Typography variant="body2" color="textSecondary">
                                <MessagesComponent tenatDetails={tenantData}
                                                   landlordID={JSON.parse(originalText)[0][1]}/>

                            </Typography>
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 3 && (
                    <StyledCard>
                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Download Files
                            </Typography>

                            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

                            <Typography variant="body2" color="textSecondary">
                                <TenantFiles files={files} tenantDetails={tenantData}
                                             originalText={originalText}
                                             propertyID={tenantData.property_id}
                                             propertyName={tenantData.property_name}/>
                            </Typography>
                        </CardContent>
                    </StyledCard>
                )}

                {activeTab === 4 && (
                    <StyledCard>
                        <CardContent>
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                color={themeColor}
                                gutterBottom
                            >
                                Tenant Report Generator
                            </Typography>

                            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

                            <Typography variant="body2" color="textSecondary">
                                <TenantReport tenantDetails={tenantData}/>
                            </Typography>
                        </CardContent>
                    </StyledCard>
                )}
            </Grid>
        </>
    );
};

export default RightSide;